import { useState, useEffect, useContext, useCallback } from "react";
import api from 'services/api';
import NAVBAR from "components/navbar";
import { FormataValor } from "functions/formatavalor"
import { getadmin, getcodCidade, getestabelecimentos } from "functions/gettabconfig";
import { formatDate, getHoje } from "components/formatos";
import VENDASModal from './modal'
import SELECT from "components/select";
import IMAGEM from "components/imagem";
import config from "config";
import MESSAGE from "components/message";
import FOOTER from "components/footer";
import AvisoPopup from "components/avisos";
import PAGINACAO from "components/paginacao";
import { CidadeContext } from "services/cidade";
import './style.css';


function VendaParceiro() {
    const [lvenda, setLVendas] = useState([]);
    const [operacao, setOperacao] = useState('')
    const [idcampanha, setIDCampanha] = useState(-1);
    const [dencampanha, setDenCampanha] = useState('');
    const [idestabelecimento, setIDEstabelecimento] = useState(getestabelecimentos(0));
    const [denestabelecimento, setDenEstabelecimento] = useState('');
    const [lparceiros, setLParceiros] = useState([]);
    const [lcampanha, setLCampanha] = useState([]);
    const [search, setSearch] = useState('');
    const [foto, setFoto] = useState('');
    const [mensagem, setMensagem] = useState('');
    // necessario para usar cidade global para admin e cidada do login para parceiro
    const { cod_cidade } = useContext(CidadeContext);
    const codcidade = getadmin() ? cod_cidade : getcodCidade();
    const [resetPage, setResetPage] = useState(false);

    // Modal
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    function novaVenda() {
        setDados({
            'id_venda': 0,
            'id_campanha': idcampanha,
            'den_campanha': dencampanha,
            'id_estabelecimento': idestabelecimento,
            'nome_estabelecimento': denestabelecimento,
            'id_usuario': -1,
            'dat_venda': getHoje(),
            'valor_venda': 0.00,
            'numero_venda': '',
            'nomeusuarios': ''
        });
        setIsOpen(true);
    }

    function editarVenda(linha) {
        api.get(`${config.PARCEIRO_VENDAS}/${linha.id_estabelecimento}/${linha.id_venda}`)
            .then(response => {
                setOperacao('UPDATE')
                setDados(response.data[0]);
                setIsOpen(true);
            }).catch(err => {
                console.log(err)
                setMensagem(err);
            })
    }

    function closeVENDASModal() {
        setIsOpen(false);
        BuscarExtrato();
    }

    const BuscaCampanha = useCallback(() => {
        api.get(`${config.CAMPANHAS}?codcidade=${codcidade}`)
            .then(response => {
                if (response.status === 200) {
                    setLCampanha(response.data);
                    setIDCampanha(response.data[0].id_campanha);
                    setDenCampanha(response.data[0].den_campanha);
                } else {
                    setMensagem('Não carregou as campanhas');
                }
            });
    }, [codcidade]);

    const BuscarExtrato = useCallback(() => {
        if (idestabelecimento > 0 && idcampanha > 0) {
            api.get(`${config.PARCEIRO_VENDAS}?id_campanha=${idcampanha}&id_estabelecimento=${idestabelecimento}`)
                .then(response => {
                    if (response.status === 200) {
                        setLVendas(response.data);
                    }
                });
        }
    }, [idestabelecimento, idcampanha]);

    const BuscaEstabelecimento = useCallback(() => {
        if (idestabelecimento > 0) {
            api.get(`${config.ADM_ESTABELECIMENTOS}/${idestabelecimento}`)
                .then(response => {
                    if (response.status === 200) {
                        setDenEstabelecimento(response.data[0].nome);
                        setFoto(response.data[0].url_logo);
                        if (response.data[0].campanhas.length === 0) {
                            setMensagem('Estabelecimento não participa da campanha');
                            console.log('1-Estabelecimento não participa da campanha')
                            setLCampanha([]);
                        } else {
                            setLCampanha(response.data[0].campanhas);
                            if (response.data[0].campanhas.length > 0) {
                                // Só atualiza a campanha se ainda não estiver setada ou se não estiver na lista
                                const campanhaExiste = response.data[0].campanhas.find(c => c.id_campanha === idcampanha);
                                if (idcampanha === -1 || !campanhaExiste) {
                                    setIDCampanha(response.data[0].campanhas[0].id_campanha);
                                    setDenCampanha(response.data[0].campanhas[0].den_campanha);
                                }
                            }
                        }
                    } else {
                        setMensagem('Estabelecimento não encontrado');
                        console.log('2-Estabelecimento não encontrado');
                        setLCampanha([]);
                    }
                }).catch(err => {
                    console.log('Erro ao buscar estabelecimento:', err);
                    setMensagem('Erro ao buscar dados do estabelecimento');
                });
        }
    }, [idestabelecimento, idcampanha]);

    useEffect(() => {
        if (resetPage) {
            setResetPage(false);
        }
    }, [resetPage]);

    useEffect(() => {
        BuscarExtrato();
    }, [idcampanha, BuscarExtrato]);

    useEffect(() => {        
        api.get(`${config.ADM_ESTABELECIMENTOS}?codcidade=${codcidade}`)
            .then(response => {
                if (response.status === 200) {
                    setLParceiros(response.data);
                    const idEstabInicial = getestabelecimentos(0);
                    setIDEstabelecimento(idEstabInicial);
                }
            })
        BuscaCampanha();
    }, [codcidade, BuscaCampanha]);

    useEffect(() => {
        if (idestabelecimento > 0) {
            BuscaEstabelecimento();
        }
    }, [idestabelecimento, BuscaEstabelecimento])


    function salvaCampanha(e) {
        const id = parseInt(e.target.value, 10);
        setIDCampanha(id);
        const lden = lcampanha.filter(f => f.id_campanha === id);
        lden.length > 0 && setDenCampanha(lden[0].den_campanha);
    }

    function setNovoEstabelecimento(e) {
        const id = parseInt(e.target.value, 10);
        setIDEstabelecimento(id);
        const lden = lparceiros.filter(f => f.id_estabelecimento === id);
        lden.length > 0 && setDenEstabelecimento(lden[0].nome);
    }

    function KeyDown(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            searchLancamento();
        }
    }

    async function searchLancamento() {
        try {
            const response = await api.get(`${config.PARCEIRO_VENDAS}?id_campanha=${idcampanha}&id_estabelecimento=${idestabelecimento}`);
            const listaall = response.data;

            const lista = listaall.filter(venda => {
                const matchNumeroVenda = venda.numero_venda.includes(search);
                const matchNomeUsuarios = venda.nomeusuarios.toLowerCase().includes(search.toLowerCase());
                return matchNumeroVenda || matchNomeUsuarios;  // Considera correspondência em um ou outro campo
            });
            setLVendas(lista);
            setResetPage(true);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    }

    return <div>
        <NAVBAR />
        <VENDASModal isOpen={isOpen}
            onRequestClose={closeVENDASModal}
            operacao={operacao}
            dados={dados}
        />
        <div className="container-fluid mt-page">
            <MESSAGE
                msg={mensagem}
            />
            <div className="me-2">
                <div className="row">
                    <div className="col-md-2">
                        {foto && <IMAGEM src={foto} width={100} />}
                    </div>
                    {getadmin() ?
                        <div className="col-md-5">
                            <label htmlFor="SELECTPARCEIRO" className="form-label">Parceiro</label>
                            <SELECT
                                key={'SELECTPARCEIRO'}
                                name={'SELECTPARCEIRO'}
                                SalvaSelect={setNovoEstabelecimento}
                                value={idestabelecimento}
                                chave={'id_estabelecimento'}
                                descricao={'nome'}
                                aoptions={lparceiros}
                                retornoe={true}
                            />
                        </div>
                        : <h2>Venda Parceiro: {denestabelecimento}</h2>
                    }
                    <div className="col-md-5">
                        <label htmlFor="SELECTCAMPANHA" className="form-label">Campanha</label>
                        <SELECT
                            key={'0001'}
                            name={'SELECTCAMPANHA'}
                            SalvaSelect={salvaCampanha}
                            value={idcampanha}
                            chave={'id_campanha'}
                            descricao={'den_campanha'}
                            aoptions={lcampanha}
                            retornoe={true}
                        />
                    </div>
                    <div className="row">
                    <div className="col-md-8 mt-4">
                        <label htmlFor="floatinginputsearch" className="form-label">Pesquisa</label>
                        <div className="input-group rounded">
                            <input type="search"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={KeyDown}
                                autoFocus={true}
                                className="form-control"
                                id="floatinginputsearch"
                                placeholder="Pesquisa lançamentos" />
                            <button className="btn btn-large"
                                type="button"
                                onClick={() => searchLancamento()}>
                                <i className="fas fa-search" /></button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <label htmlFor="Acoes" className="form-label">Ação</label>
                        <div className="toolbar">
                            <button type="button" className="toolbar-button form-control"
                                onClick={() => novaVenda()}
                            ><i className="fas fa-plus"></i></button>
                            <button type="button" className="toolbar-refresh form-control"
                                onClick={() => BuscarExtrato()}
                            ><i className="fas fa-sync"></i></button>
                        </div>
                    </div>
                    </div>
                </div>
                <PAGINACAO
                    resetPage={resetPage}
                    data={lvenda}
                    itemsPerPage={20}
                    renderItems={(currentItems) => (
                        <table className="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" className="d-none d-md-table-cell hidden-sm">Destinatário</th>
                                    <th scope="col">Data</th>
                                    <th scope="col">Valor</th>
                                    <th scope="col">operação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map((e, index) => (
                                    <tr key={`vnd${index}`}>
                                        <th scope="row">{e.numero_venda}</th>
                                        <td className="d-none d-md-table-cell hidden-sm">{e.nomeusuarios}</td>
                                        <td>{formatDate(e.dat_venda)}</td>
                                        <td align="right">{FormataValor(e.valor_venda, 'NUMEROD2')}</td>
                                        <td><button className='btn btn-danger'
                                            type="button"
                                            onClick={() => editarVenda(e)}>
                                            <i className="fas fa-edit"></i></button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                />
            </div>
        </div>
        <FOOTER />
        <AvisoPopup />
    </div>

}
export default VendaParceiro;